import { useState, useEffect } from "react";
import './App.css';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';
import CancelIcon from '@mui/icons-material/Cancel';
import LinearProgress from '@mui/material/LinearProgress';





interface BackendState {
  name: string;
  description: string;
  database: string;
  status: string;
}

async function fetchBackendState(): Promise<BackendState[]> {
  let baseUrl = window.location.origin === 'http://localhost:3000'
    ? 'http://localhost:5000'
    : `${window.location.origin}/backend`;


  const response = await fetch(`${baseUrl}/datasource_status`);
  const data = await response.json();
  console.log(data);
  return data.datasources;
}

interface License {
  name: string;
  date: string;
  valid: boolean;
}

async function checkLicense(): Promise<License> {
  let baseUrl = window.location.origin === 'http://localhost:3000'
    ? 'http://localhost:5000'
    : `${window.location.origin}/backend`;

  const response = await fetch(`${baseUrl}/license_data`);
  const data = await response.json();
  console.log(data);

  let license = {name: data.Name, date: data.Date, valid: false};

  let date = data.Date
  let name = data.Name
  let key = BigInt(data.Key)

  let salt = "1234567890"
  let string = name + date + salt
  let hash : bigint = 0n
  for (let i = 0; i < string.length; i++) {
    hash = ((hash << 5n) - hash) + BigInt(string.charCodeAt(i));
  }

  console.log("Check:", hash == key);
  console.log(hash);
  console.log(key);

  if(hash == key)
  {
    if (Date.now() <= Date.parse(date))
    {
      license.valid = true;
    }
  }
  
  console.log("License", license);

  return license
}


function App() {

  const [backend_state, setBackendState] = useState<BackendState[]>([]);

  const [license, setLicense] = useState<License>({name: "Unknown", date: "", valid: false});

  useEffect(() => {
    fetchBackendState().then((data) => setBackendState(data));
    checkLicense().then((data) => setLicense(data));
  }, []);

  const logoForDatasource = (database: string) =>
  {
    switch(database)
    {
      case 'MSSQL':
        return <img src={process.env.PUBLIC_URL + 'extension/MicrosoftSQLLogo.png'} width={25} height={25} alt={database}/>
      case 'PostgreSQL':
        return <img src={process.env.PUBLIC_URL + 'extension/PostgreSQLLogo.png'} width={25} height={25} alt={database}/>
      case 'Snowflake':
        return <img src={process.env.PUBLIC_URL + 'extension/SnowflakeLogo.png'} width={25} height={25} alt={database}/>
    }
  }

  let trex_url = window.location.origin === 'http://localhost:3000'
    ? 'http://localhost:5000/download_trex'
    : `${window.location.origin}/backend/download_trex`;

  const backend_status_list = backend_state.map(db_connection =>
    <Paper sx={{ p: 1 }} elevation={5}>
      <Stack direction='row' spacing={1} padding={0} alignItems="center">
        {logoForDatasource(db_connection.database)}
        <Typography variant="h5" component="div">
          {db_connection.name}
        </Typography>
      </Stack>
      <Box
        display="flex"
        justifyContent="left"
        alignItems="left"
      >
        {db_connection.status ?
          <CheckCircleSharpIcon sx={{ p: 1, color: 'green', fontSize: 50 }}/>
        : <CancelIcon sx={{ p: 1, color: 'red', fontSize: 50 }}/>}
        {db_connection.description}
      </Box>
    </Paper>
  );

  return (
    <Container maxWidth="lg">
      <Stack direction='column' spacing={4} margin={4}>
          <Typography variant="h3" component="div">
            Combleau
          </Typography>
          <Paper elevation={3} sx={{ p: 1 }}>
            <Typography variant="h4" component="div">
              Status
            </Typography>
            
            <Stack direction='column' spacing={2} margin={1}>
                {backend_state.length > 0 ? backend_status_list : <Box sx={{ width: '100%' }}>
                    <LinearProgress />
                  </Box>
                }
            </Stack>

          </Paper>

          <Paper elevation={3} sx={{ p: 1, pb: 3 }}>
            <Typography variant="h4" component="div">
              Extension File
            </Typography>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Button variant="outlined" color="success" endIcon={<FileDownloadIcon />} sx={{ p: 3 }} href={trex_url}>
                Download Extension File
              </Button>
            </Box>
          </Paper>

          <Paper elevation={3} sx={{ p: 1 }}>
            <Typography variant="h4" component="div">
              Documentation
            </Typography>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Button href="documentation">Open Documentation</Button>
            </Box>
          </Paper>

          <Paper elevation={3} sx={{ p: 1 }}>
            <Typography variant="h4" component="div">
              License
            </Typography>
            <Box
              display="flex"
              justifyContent="left"
              alignItems="left"
            >
              {license.valid ?
                <CheckCircleSharpIcon sx={{ p: 1, color: 'green', fontSize: 50 }}/>
              : <CancelIcon sx={{ p: 1, color: 'red', fontSize: 50 }}/>}

              <Stack direction='column'>
                <Typography variant="h5" component="div">Valid until</Typography>
                <Typography variant="body1" component="div">{license.date}</Typography>
              </Stack>
            </Box>
          </Paper>
      </Stack>
    </Container>
  );
}

export default App;
